import { FavySoftwareLayout } from "./FavySoftwareLayout";
import { ThemeContext, TRUSTPILOT_REVIEW_WIDGET } from "./ThemeContext";

export const FavySoftwareTrustpilot = (props) => (
	<ThemeContext.Provider
		value={{ reviewWidget: TRUSTPILOT_REVIEW_WIDGET, ...props }}
	>
		<FavySoftwareLayout {...props} />
	</ThemeContext.Provider>
);
